import { cn } from '@/lib/cn';

export function BrandMark({ className, ring = true }: { className?: string; ring?: boolean }) {
  return (
    <span
      className={cn(
        'inline-block shrink-0 overflow-hidden rounded-full bg-[#f6f3e4]',
        ring && 'ring-2 ring-white shadow-soft dark:ring-navy-700',
        className,
      )}
    >
      <img src="/brand/medicail-mark.webp" alt="" width={512} height={512} className="size-full scale-[1.12] object-cover" draggable={false} />
    </span>
  );
}

export function Wordmark({ className, markClassName }: { className?: string; markClassName?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <BrandMark className={cn('size-9', markClassName)} />
      <span className="font-heading text-[1.3rem] font-semibold tracking-tight text-ink">
        Medic<span className="text-link">Ai</span>L
      </span>
    </span>
  );
}
